import * as types from './types';

const fetchCredits = (queryParams = null) => ({
  type: types.FETCH_CREDITS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/credits',
    query: queryParams,
    method: 'GET'
  }
});

const invalidateCredits = () => ({
  type: types.INVALIDATE_CREDITS
});

const selectCredit = (publicationPlanId, branchId) => ({
  type: types.SELECT_CREDIT,
  payload: { publicationPlanId, branchId }
});

const getPublicationPlansByOperationType = (operationType, publisherType) => ({
  type: types.PUBLICATION_PLANS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/panel/api/v2/credits/publicationplans',
    query: { operationType, publisherType },
    method: 'GET'
  }
});

export { fetchCredits, invalidateCredits, selectCredit, getPublicationPlansByOperationType };
